import React from 'react';
import { useSidebar } from '@contexts/SidebarContext';

export const Backdrop: React.FC = () => {
  const { isMobileOpen, toggleMobileSidebar } = useSidebar();

  if (!isMobileOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-sm z-30 md:hidden"
      onClick={toggleMobileSidebar}
    />
  );
};
